import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import { BuyerInfo, IDType, IDTypes, PrvSellLookUp, PvtSellLookUp } from "../../../apis/privatesell/enitites";
import FormRow from "@eres/forms-web/FormRow";
import FixedEidInput from "@my-dld/components/FixedEidInput";
import { EidStateFormatter } from "@my-dld/screens/Login/owner/EID";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { privateSellApi } from "../../../apis/privatesell";
import { IPrivateSellForm, IPrivateSellFormProps, IPrivateSellFormState } from "./Base";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { DateUtil, LocaleUtil, StringUtil } from "@eres/core";
import I8N from "@eres/core/dist/I8N";
import { populatePrvtSellLookup } from "../../../apis/privatesell/services";
import PickerInput from "@my-dld/components/Form/PickerInput";
import DateInputField from "@eres/forms-web/DateInputField";

interface Props extends IPrivateSellFormProps {
	children?: any;
	buyerInfo?: BuyerInfo;
}

interface State extends Partial<BuyerInfo>, IPrivateSellFormState {
	errorContainer: ErrorContainer;
	IdType: IDType;
	editableName: boolean;
	buyerName?: string;
	Countries: PvtSellLookUp[];
	dob?: string;
}

export default class BuyerInfoDetail extends Component<Props, State> implements IPrivateSellForm<Props, State> {
	today = new Date();

	constructor( props: Props ) {
		super( props );
		this.state = {
			...props.buyerInfo,
			buyerName: props.buyerInfo ? LocaleUtil.getLocalValue( props.buyerInfo.name ) : undefined,
			isValid: false,
			errorContainer: {},
			IdType: IDTypes[ 0 ],
			editableName: props.buyerInfo && props.buyerInfo.emiratesId != undefined ? false : true,
			Countries: [],
		};
		this.today = new Date();
	}

	componentDidMount(): void {
		populatePrvtSellLookup( PrvSellLookUp.PRVSell_COUNTRY, this );
	}

	setError( key: string, error: string | undefined ) {
		this.setState( s => {
			return {
				errorContainer: {
					...s.errorContainer,
					[ key ]: error ? error : "",
				}
			};
		} );
	}

	isValid = ( _isUserAction?: boolean ) => {
		const state = this.state;
		let isValid = true;
		let errorViews: ErrorContainer = {};
		if ( state.IdType.Id === 1 ) {
			isValid = checkNonEmpty( state, "emiratesId", errorViews ) && isValid;
		} else {
			isValid = checkNonEmpty( state, "nationality", errorViews ) && isValid;
			isValid = checkNonEmpty( state, "passportNumber", errorViews ) && isValid;
		}
		isValid = checkNonEmpty( state, "buyerName", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "mobile", errorViews ) && isValid;
		if ( isValid ) {
			isValid = validateMobile( errorViews, state, "mobile" ) && isValid;
		}
		isValid = checkNonEmpty( state, "email", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "dob", errorViews ) && isValid;
		if ( isValid ) {
			isValid = validateEmail( errorViews, state, "email" ) && isValid;
		}
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};

	nameEditProvider = () => {
		if ( this.state.IdType === IDTypes[ 0 ] ) return this.state.editableName;
		return true;
	};
	// componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
	//     const oldData = this.getData(prevState);
	//     const newData = this.getData(this.state);
	//     handleDataUpdate(oldData, newData, prevState, this);
	// }

	getData = ( state: State = this.state ) => {
		const isUAEResidence = this.state.IdType.Id === 1;
		return {
			...state,
			emiratesId: isUAEResidence ? state?.emiratesId : undefined,
			name: I8N.locale() === "ar" ? { arabicName: this.state?.buyerName } : { englishName: this.state?.buyerName },
			nationality: !isUAEResidence ? state?.nationality : undefined,
			passportNumber: !isUAEResidence ? state?.passportNumber : undefined,
			birthDate: state.dob?.asDate()?.asServerString(),
			mobile: StringUtil.normaliseMobileNumber( state.mobile ?? "" ),
			Countries: undefined,
			editableName: undefined,
			IdType: undefined,
			isValid: undefined,
			errorContainer: undefined,
			dob: undefined,
		};
	};


	render() {
		const { readonly, children } = this.props;
		const { errorContainer, IdType, Countries } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		return (
			<div className="tender-registration-form">
				<FormSection title={ Strings.buyer_information }>
					<FormRow { ...filedProps }>
						{
							IdType.Id === 1 &&
							<>
								<FormRow { ...filedProps } >
									<FixedEidInput
										disabled={ readonly }
										containerClassName={ "form-group col-md-4" }
										id={ "emiratesId" }
										label={ Strings.emirates_id_number }
										error={ errorContainer.emiratesId }
										onValueChange={ () => {
											this.setState( s => {
												return {
													errorContainer: {
														...s.errorContainer,
														[ "emiratesId" ]: undefined,
													} as unknown as ErrorContainer,
												};
											} );
										} }
										required={ true }
										holder={ this }
										placeHolder={ "784-XXXX-XXXXXX-X" }
										stateFormatter={ EidStateFormatter }
									/>
									<DateInputField
										required={ true }
										id={ "dob" }
										label={ Strings.date_of_birth }
										containerClassName={ "form-group col-md-4" }
										extraOpts={ {
											maxDate: this.today,
											yearRange: "-100:+0"
										} }
									>
									</DateInputField>
									<div className={ "col-md-4 d-flex align-items-center" }>
										<button
											disabled={ false } className="btn btn_1" type="button" onClick={ this.onDNRD }>{ Strings.verify }</button>
									</div>
								</FormRow>
								<FormRow { ...filedProps } >

								</FormRow>
							</>
						}
						{
							IdType.Id === 2 &&
							<>
								<div className="col-4">
									<PickerInput
										{ ...kvProp }
										disabled={ readonly }
										label={ Strings.nationality }
										id={ "nationality" }
										items={ Countries }
										containerClassName="form-group field-style select-control"
										required={ true }
										error={ errorContainer.nationality }
										toIdentifier={ ( item: PvtSellLookUp ) => item.identity + "" }
										onValueChange={ ( country?: PvtSellLookUp ) => {
											this.setState( { nationality: country } );
										} }
									/>
								</div>
								<div className={ "col-4" }>
									<TextInputField
										{ ...filedProps }
										id={ "passportNumber" }
										required={ true }
										containerClassName="form-group"
										label={ Strings.passport_number }
									/>
								</div>
							</>
						}
						<div className={ "col-4" }>
							<TextInputField
								{ ...filedProps }
								id={ "buyerName" }
								disabled={ !this.nameEditProvider() }
								required={ true }
								containerClassName="form-group"
								label={ Strings.name_as_per_id }
							/>
						</div>
					</FormRow>
					<FormRow { ...filedProps } >
						<TextInputField
							id={ "mobile" }
							required={ true }
							containerClassName="form-group col-md-4"
							label={ Strings.mobile_number }
							disabled={ false }
						/>
						<TextInputField
							{ ...filedProps }
							placeHolder={ Strings.email_placeholder }
							id={ "email" }
							error={ errorContainer.email }
							containerClassName="form-group col-md-4"
							label={ Strings.email }
							required={ true }
							maxLength={ 256 }
						/>
					</FormRow>
					{ children }
				</FormSection>
			</div>
		);
	}

	onDNRD = () => {
		const { emiratesId, dob, errorContainer } = this.state;
		const state = this.state;
		let isValid = true;
		let errorViews: ErrorContainer = { ...errorContainer, emiratesId: undefined, dob: undefined } as unknown as ErrorContainer;
		isValid = checkNonEmpty( state, "emiratesId", errorViews ) && isValid;
		if ( isValid && emiratesId && emiratesId.length !== 15 ) {
			errorViews[ "emiratesId" ] = Strings.invalid_data;
			isValid = false;

		}
		isValid = checkNonEmpty( state, "dob", errorViews ) && isValid;
		this.setState( { errorContainer: errorViews } );
		if ( isValid ) {
			this.loadDataFromEID( dob! );
		}
	};
	loadDataFromEID = ( dob: string ) => {
		showLoading();
		// this.props.onFormLoad(true);
		const dobS = DateUtil.formatDate( dob?.asDate()!, "MM-DD-YYYY", "en" );
		const apiHandler = ( response: any ) => {
			//  this.props.onFormLoad(false);
			hideLoading();
			trackEventWithData( "PrivateSell", "ValidatePerson", { emiratesID: this.state.emiratesId + "" } );
			if ( response && response.name && response.name.englishName ) {
				this.setState( {
					...response,
					buyerName: LocaleUtil.getLocalValue( response.name ),
					editableName: false,
				} );
			} else {
				this.setState( {
					editableName: true,
				} );
			}
		};
		const apiExHandler = ( e: any ) => {
			if ( e?.message ) {
				showErrorMessage( e?.message );
			}
			this.setState( {
				editableName: true,
			} );
			//  this.props.onFormLoad(false);
			hideLoading();
		};
		privateSellApi.validatePersonByEmiratesId( this.state.emiratesId!, dobS ).then( apiHandler ).catch( apiExHandler );
	};
}

function validateMobile( errorViews: ErrorContainer, state: any,
                         key: string = "Mobile" ): boolean {
	let isValid = true;
	let mob = StringUtil.normaliseMobileNumber( state[ key ] );
	if ( mob == undefined || mob.length < 12 ) {
		isValid = false;
		errorViews[ key ] = Strings.invalid_mobile;
	}
	return isValid;
}

function validateEmail( errorViews: ErrorContainer,
                        state: any,
                        key: string = "Email" ): boolean {
	let isValid = true;
	let email = state[ key ];
	if ( !StringUtil.isEmailAddress( email ) ) {
		isValid = false;
		errorViews[ key ] = Strings.invalid_email;
	}
	return isValid;
}
